import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

export default function CookieConsent() {
  const [showBanner, setShowBanner] = useState(false);
  
  useEffect(() => {
    const consent = localStorage.getItem("cookie_consent");
    if (!consent) {
      // Small delay before showing
      setTimeout(() => setShowBanner(true), 1000);
    }
  }, []);
  
  const handleAccept = () => {
    localStorage.setItem("cookie_consent", "accepted");
    localStorage.setItem("cookie_consent_date", new Date().toISOString());
    setShowBanner(false);
  };
  
  const handleDecline = () => {
    localStorage.setItem("cookie_consent", "declined");
    localStorage.setItem("cookie_consent_date", new Date().toISOString());
    setShowBanner(false);
  };
  
  if (!showBanner) return null;
  
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-white border-t border-slate-200 shadow-lg animate-slide-up">
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="flex-1">
          <p className="text-sm text-slate-600">
            We use cookies to enhance your experience, personalize content, and analyze traffic. 
            By continuing to use Savecation, you agree to our{" "}
            <a href="/privacy" className="text-sky-600 hover:underline">Privacy Policy</a> and{" "}
            <a href="/terms" className="text-sky-600 hover:underline">Terms of Service</a>.
          </p>
        </div>
        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={handleDecline}
            className="text-slate-600"
          >
            Decline
          </Button>
          <Button
            size="sm"
            onClick={handleAccept}
            className="bg-sky-500 hover:bg-sky-600"
          >
            Accept All
          </Button>
        </div>
        <button 
          onClick={handleDecline}
          className="absolute top-2 right-2 sm:hidden text-slate-400 hover:text-slate-600"
        >
          <X className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
}
